import background from './backgrounds/background.jpg' ;

export default background;